export const formatResultQueries = listResult => {
  const isIdleQuery = item => {
    // React Query old version
    if (typeof item.isIdle !== "undefined") {
      return item.isIdle;
    }

    // @tanstack/react-query v4/v5
    // Disabled query / not started yet
    return (
      item.fetchStatus === "idle" &&
      !item.isFetching &&
      !item.isSuccess &&
      !item.isError &&
      item.data === undefined
    );
  };

  const listEnabledResult = listResult.filter(item => !isIdleQuery(item));

  const countEnabled = listEnabledResult.length;

  const isAllSuccess =
    countEnabled > 0 && listEnabledResult.every(item => item.isSuccess);

  const isAllLoading =
    countEnabled > 0 &&
    listEnabledResult.every(item => item.isFetching || item.isLoading);
  const data = {
    isAllSuccess,
    isAllLoading,
    listData: listResult.map(item => item.data),
    result: listResult,
  };
  if (isAllSuccess) {
    // console.log("formatResultQueries", { countEnabled, data });
  }

  return data;
};
